// extracted by mini-css-extract-plugin
export var layoutContainer = "_4g-0";
export var layoutContainerOpen = "_4g-5";
export var layoutContainerResizing = "_4g-1";
export var mainContent = "_4g-2";
export var resizeDivider = "_4g-3";
export var slidePanel = "_4g-4";